import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	getSubtasksErrorTitle: {
		id: 'work-management-board.services.get-subtasks-jis.get-subtasks-error-title',
		defaultMessage: 'Failed to load subtasks',
		description:
			'Title in flag message shown to user when there was an error loading subtasks for an issue on the board',
	},
	getSubtasksErrorMessage: {
		id: 'work-management-board.services.get-subtasks-jis.get-subtasks-error-message',
		defaultMessage:
			'Something went wrong while loading subtasks. Please try again or contact your administrator if the problem persists.',
		description:
			'Flag message shown to user when there was an error loading subtasks for an issue on the board',
	},
});
